<template>
  <v-dialog v-model="dialog_export" persistent max-width="800px">
    <v-form ref="form" v-model="valid">
      <v-card>
        <v-card-title>
          <span class="headline">Gerar Exportação</span>
          <v-spacer />
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm3 md3>
                <v-autocomplete
                  :items="collections"
                  item-value="value"
                  item-text="text"
                  label="Coleção"
                  v-model.lazy="collection"
                  :rules="[(v) => !!v || 'Por favor, selecione a coleção!']"
                  :hint="'Selecione uma coleção'"
                  required
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12 sm3 md3>
                <v-text-field
                  label="Nome da Exportação"
                  v-model="name"
                  required
                  :rules="[
                    (v) =>
                      !!v || 'Por favor, informe um nome para a exportação',
                    (v) =>
                      v.length > 10 ||
                      'Ops. O nome da exportação deve conter no mínimo 10 caracteres',
                  ]"
                  :hint="'Mínimo de 10 caracteres'"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12 v-if="collection === 'users'">
                <v-layout wrap>
                  <v-flex xs3 sm3 md3>
                    <v-text-field
                      label="Data Inicio"
                      v-model="start"
                      required
                      mask="##/##/####"
                      :rules="[
                        (v) => !!v || 'Por favor, informe a data inicial',
                        (v) =>
                          this.isDate(this.formatDate(v)) === true ||
                          'Ops. Parece que esse não é um data valida.',
                      ]"
                      return-masked-value
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3 sm3 md3>
                    <v-text-field
                      label="Data Fim"
                      v-model="finish"
                      required
                      mask="##/##/####"
                      :rules="[
                        (v) => !!v || 'Por favor, informe a data final',
                        (v) =>
                          this.isDate(this.formatDate(v)) === true ||
                          'Ops. Parece que esse não é um data valida.',
                        (v) =>
                          this.validaDataMaior(
                            this.formatDate(v),
                            this.formatDate(this.start),
                          ) === true ||
                          'Data final precisa ser maior que data de inicio.',
                      ]"
                      return-masked-value
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 md12 v-if="collection === 'leads'"
                ><v-layout wrap>
                  <v-flex xs12 sm3 md3>
                    <v-text-field
                      label="Data Inicio"
                      v-model="start"
                      required
                      mask="##/##/####"
                      :rules="[
                        (v) => !!v || 'Por favor, informe a data inicial',
                        (v) =>
                          this.isDate(this.formatDate(v)) === true ||
                          'Ops. Parece que esse não é um data valida.',
                      ]"
                      return-masked-value
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm3 md3>
                    <v-text-field
                      label="Data Fim"
                      v-model="finish"
                      required
                      mask="##/##/####"
                      :rules="[
                        (v) => !!v || 'Por favor, informe a data final',
                        (v) =>
                          this.isDate(this.formatDate(v)) === true ||
                          'Ops. Parece que esse não é um data valida.',
                        (v) =>
                          this.validaDataMaior(
                            this.formatDate(v),
                            this.formatDate(this.start),
                          ) === true ||
                          'Data final precisa ser maior que data de inicio.',
                      ]"
                      return-masked-value
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 md12 v-if="collection === 'consumer_units'"
                ><v-layout wrap>
                  <v-flex xs12 sm3 md3>
                    <v-autocomplete
                      :items="filteredPowerPlants"
                      item-text="name"
                      item-value="power_plant_id"
                      label="Planta"
                      v-model="powerPlant"
                      :rules="
                        start != '' && finish != ''
                          ? []
                          : [(v) => !!v || 'Por favor, informe a planta']
                      "
                    ></v-autocomplete>
                    <!-- <v-text-field
                      label="Planta"
                      v-model="powerPlant"
                      :rules="start != '' && finish != '' ? [] : [(v) => !!v || 'Por favor, informe a planta']"
                    ></v-text-field> -->
                  </v-flex>
                  <v-flex xs12 sm3 md3>
                    <v-text-field
                      label="Data Inicio"
                      v-model="start"
                      :required="powerPlant === ''"
                      mask="##/##/####"
                      :rules="
                        powerPlant != ''
                          ? []
                          : [
                              (v) => !!v || 'Por favor, informe a data inicial',
                              (v) =>
                                this.isDate(this.formatDate(v)) === true ||
                                'Ops. Parece que esse não é um data valida.',
                            ]
                      "
                      return-masked-value
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm3 md3>
                    <v-text-field
                      label="Data Fim"
                      v-model="finish"
                      :required="powerPlant === ''"
                      mask="##/##/####"
                      :rules="
                        powerPlant != ''
                          ? []
                          : [
                              (v) => !!v || 'Por favor, informe a data final',
                              (v) =>
                                this.isDate(this.formatDate(v)) === true ||
                                'Ops. Parece que esse não é um data valida.',
                              (v) =>
                                this.validaDataMaior(
                                  this.formatDate(v),
                                  this.formatDate(this.start),
                                ) === true ||
                                'Data final precisa ser maior que data de inicio.',
                            ]
                      "
                      return-masked-value
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 md12 v-if="collection === 'billing'"
                ><v-layout wrap>
                  <v-flex xs12 sm3 md3>
                    <v-autocomplete
                      :items="filteredPowerPlants"
                      item-text="name"
                      item-value="power_plant_id"
                      label="Planta"
                      v-model="powerPlant"
                      :rules="
                        competence != ''
                          ? [(v) => !!v || 'Por favor, informe a planta']
                          : []
                      "
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm3 md3>
                    <v-text-field
                      label="Competência"
                      v-model="competence"
                      required
                      mask="##/####"
                      :rules="
                        start != '' && finish != ''
                          ? []
                          : [(v) => !!v || 'Por favor, informe a competência']
                      "
                      return-masked-value
                      hint="MM/AAAA"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm3 md3>
                    <v-text-field
                      label="Data Inicio"
                      v-model="start"
                      :required="competence === ''"
                      mask="##/##/####"
                      :rules="
                        competence != ''
                          ? [
                              (v) =>
                                !v ||
                                'Não é possível informar datas e competência',
                            ]
                          : [
                              (v) => !!v || 'Por favor, informe a data inicial',
                              (v) =>
                                this.isDate(this.formatDate(v)) === true ||
                                'Ops. Parece que esse não é um data valida.',
                            ]
                      "
                      return-masked-value
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm3 md3>
                    <v-text-field
                      label="Data Fim"
                      v-model="finish"
                      :required="competence === ''"
                      mask="##/##/####"
                      :rules="
                        competence != ''
                          ? [
                              (v) =>
                                !v ||
                                'Não é possível informar datas e competência',
                            ]
                          : [
                              (v) => !!v || 'Por favor, informe a data final',
                              (v) =>
                                this.isDate(this.formatDate(v)) === true ||
                                'Ops. Parece que esse não é um data valida.',
                              (v) =>
                                this.validaDataMaior(
                                  this.formatDate(v),
                                  this.formatDate(this.start),
                                ) === true ||
                                'Data final precisa ser maior que data de inicio.',
                            ]
                      "
                      return-masked-value
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 md12 v-if="collection === 'revenues'">
                <v-layout wrap>
                  <v-flex xs12 sm3 md3>
                    <v-autocomplete
                      :items="power_plants"
                      prepend-icon="flash_on"
                      label="Planta"
                      item-text="name"
                      item-value="id"
                      v-model="powerPlant"
                      :rules="[
                        (v) =>
                          !!v || 'Selecione a Planta que deseja ver fatura',
                      ]"
                    ></v-autocomplete>
                    <!-- <v-autocomplete
                      :items="filteredPowerPlants"
                      item-text="name"
                      item-value="power_plant_id"
                      label="Planta"
                      v-model="powerPlant"
                      :rules="[(v) => !!v || 'Por favor, informe a planta']"
                    ></v-autocomplete> -->
                  </v-flex>
                  <v-flex xs12 sm3 md3>
                    <v-text-field
                      label="Competência"
                      v-model="competence"
                      required
                      mask="##/####"
                      :rules="[
                        (v) => !!v || 'Por favor, informe a competência',
                      ]"
                      return-masked-value
                      hint="MM/AAAA"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-textarea
                  name="description"
                  label="Descrição"
                  v-model="description"
                  value=""
                  hint="Adicione uma descrição para sua exportação"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
          <v-alert
            :value="alert.value"
            :color="alert.color"
            :icon="alert.icon"
            outline
            dismissible
          >
            <p v-html="alert.message"></p>
          </v-alert>
          <!-- <small>*indicates required field</small> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialog_export = false"
            >fechar</v-btn
          >
          <v-btn
            color="blue darken-1"
            :loading="loading"
            :disabled="!valid || loading"
            @click.prevent="validate"
            type="submit"
            >Salvar</v-btn
          >
        </v-card-actions>
      </v-card>

      <v-snackbar
        :color="color"
        :bottom="bottom"
        :top="top"
        :left="left"
        :right="right"
        v-model="snackbar"
        dark
      >
        <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
        <div>{{ snackMessage }}</div>
        <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
      </v-snackbar>
    </v-form>
  </v-dialog>
</template>
<script>
import { eventBus } from "../../main";
import moment from "moment";
import firestore from "../../firebase/firestore";
// import { GET_POWERPLANTCOMBO } from "../../graphql/powerplants"
import { mapState, mapActions } from "vuex";

export default {
  data: function () {
    return {
      power_plants: [
        {
          id: "Todas usinas",
          name: "Todas usinas",
        },
      ],
      dialog_export: false,
      valid: false,
      collections: [
        {
          text: "Membros",
          value: "users",
        },
        {
          text: "Cobrança",
          value: "billing",
        },
        {
          text: "Faturamento",
          value: "revenues",
        },
        {
          text: "Leads",
          value: "leads",
        },
        {
          text: "Unidades Consumidoras",
          value: "consumer_units",
        },
      ],
      collection: null,
      powerPlant: "",
      competence: "",
      start: moment(new Date()).format("dd/mm/yyyy"),
      finish: moment(new Date()).format("dd/mm/yyyy"),
      name: "",
      description: "",
      loading: false,
      color: null,
      colors: ["purple", "info", "success", "warning", "error"],
      alert: {
        value: false,
        color: "success",
        icon: "check_circle",
        message: "",
      },
      top: true,
      bottom: false,
      left: false,
      right: false,
      snackMessage: "",
      snackbar: false,
    };
  },
  watch: {
    power_plants() {
      if (!this.power_plants && this.powerplants) {
        this.power_plants = this.filterPowerPlants(this.powerplants);
      }
    },
  },
  async created() {
    // console.log('created createCustomer')
    if (!this.powerplants) {
      const pp = await this.getPowerPlants();
      this.power_plants = this.filterPowerPlants(pp);
    }

    var vm = this;
    eventBus.$on("dialog_export", function (value) {
      vm.clearFilters();
      vm.dialog_export = value;
    });
  },
  computed: {
    ...mapState(["powerplants", "user"]),
    // filterPowerPlants(_powerplants) {
    //   var PowerPlantArray = []
    //   if(_powerplants && this.user) {
    //     if(this.user.group
    //         && (this.user.group.indexOf('admin') >= 0 ||
    //           this.user.group.indexOf('financial') >= 0))
    //       return _powerplants
    //     const user_pp = this.user.powerplants || this.user.power_plants

    //     if(user_pp && user_pp.length > 0) {
    //       _powerplants.filter((power_plant) => {
    //         return user_pp.filter((power_plant2) => {
    //           if(power_plant2.power_plant_id === power_plant.id) {
    //             PowerPlantArray.push(power_plant)
    //           }
    //         })
    //       });
    //     }
    //   }
    //   return PowerPlantArray
    // },
  },
  // apollo: {
  //   powerplants: {
  //     query: GET_POWERPLANTCOMBO,
  //     // Optional result hook
  //     result({ data, loading }) {
  //       this.power_plants = data.powerplants
  //       this.loading = loading
  //     },
  //     // Error handling
  //     error(error) {
  //       console.error("We've got an error!", error)
  //     },
  //   },
  // },
  methods: {
    ...mapActions(["getPowerPlants"]),
    clearFilters() {
      this.valid = false;
      this.collection = null;
      this.start = "";
      this.finish = "";
      this.name = "";
      this.description = "";
      this.powerPlant = "";
      this.competence = "";
      this.alert = {
        value: false,
        color: "success",
        icon: "check_circle",
        message: "",
      };
    },
    filterPowerPlants(_powerplants) {
      var PowerPlantArray = [];
      if (_powerplants && this.user) {
        if (
          this.user.group &&
          (this.user.group.indexOf("admin") >= 0 ||
            this.user.group.indexOf("financial") >= 0)
        )
          return _powerplants;
        const user_pp = this.user.powerplants || this.user.power_plants;

        if (user_pp && user_pp.length > 0) {
          _powerplants.filter((power_plant) => {
            return user_pp.filter((power_plant2) => {
              if (power_plant2.power_plant_id === power_plant.id) {
                PowerPlantArray.push(power_plant);
              }
            });
          });
        }
      }
      return PowerPlantArray;
    },
    showAlert(message, color, icon) {
      this.alert = {
        value: true,
        message,
        color,
        icon,
      };
    },
    snack(message, color, ...args) {
      this.top = false;
      this.bottom = false;
      this.left = false;
      this.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },
    formatDate(value) {
      if (!value || value === "") return "";
      let day = value.split("/")[0];
      let month = value.split("/")[1];
      let year = value.split("/")[2];
      return year + "-" + month + "-" + day;
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        // console.log(this.formatDate(this.start))
        let start = this.formatDate(this.start);
        let finish = this.formatDate(this.finish);
        if (new Date(start).getTime() === new Date(finish).getTime()) {
          start = start + " 00:00:00";
          finish = finish + " 23:59:59";
        }

        let export_obj = {
          created_at: new Date(),
          owner: this.user.email,
          ownerHash: this.user.id,
          filtered: true,
          solved: false,
          type: this.collection,
          name: this.name,
          description: this.description,
        };
        if (start != "" && finish != "") {
          export_obj.start = start;
          export_obj.finish = finish;
        }
        if (this.powerPlant != "") {
          export_obj.powerPlant = this.powerPlant;
        }
        if (this.competence != "") {
          let comp = this.competence.split("/");
          export_obj.competence = comp[1] + "-" + comp[0];
        }
        firestore
          .collection("exports")
          .add(export_obj)
          .then(() => {
            this.showAlert(
              "Exportação solicitada com sucesso. Você receberá sua lista no email " +
                this.user.email +
                '.<br> Caso queira acompanhar o resultado do processamento e baixar a lista <a href="/listas">clique aqui</a>',
              "green",
              "check_circle",
            );
            // this.snack('Exportação solicitada com sucesso, para acompanhar o resultado clique aqui', 'green', 'top')
            this.loading = false;
          })
          .catch((err) => {
            this.showAlert(
              "Erro ao gerar exportação. " + err,
              "error",
              "warning",
            );
            // this.snack('Erro ao gerar exportação. ' + err, 'red', 'top')
            this.loading = false;
          });
      }
    },
    validaDataMaior(start, finish) {
      // console.log('start Parse', Date.parse(start))
      let new_start = new Date(start);
      let new_finish = new Date(finish);
      // console.log(new_finish.getTime() <= new_start.getTime())
      return new_finish.getTime() <= new_start.getTime();
    },
    isDate(dateString) {
      var regEx = /^\d{4}-\d{2}-\d{2}$/;
      if (!dateString.match(regEx)) return false; // Invalid format
      var d = new Date(dateString);
      var dNum = d.getTime();
      if (!dNum && dNum !== 0) return false; // NaN value, Invalid date
      return d.toISOString().slice(0, 10) === dateString;
    },
  },
};
</script>
